<script setup lang="ts">
  import { UIAvatar, UIButton, UIPopover, UITextSmNormal } from '@gohighlevel/ghl-ui'
  import { useStore } from '@/utils/store'
  import { LogOut01Icon } from '@gohighlevel/ghl-icons/24/outline'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
  const store = useStore()

  const goToStore = () => {
    window.open('/')
  }
</script>
<template>
  <nav class="flex justify-between items-center flex-wrap gap-4">
    <div class="flex items-center gap-6">
      <span
        @click="goToStore()"
        class="font-semibold text-base cursor-pointer overflow-hidden whitespace-nowrap overflow-ellipsis max-w-32 lg:max-w-fit"
      >
        {{ store.storeName }}
      </span>

      <RouterLink to="/orders" class="font-semibold text-base no-underline text-gray-950 lg:block hidden" active-class="!text-primary-700">
        {{ t('nav.orders') }}
      </RouterLink>
      <RouterLink
        to="/wishlist"
        class="font-semibold text-base no-underline text-gray-950 lg:block hidden"
        active-class="!text-primary-700"
      >
        {{ t('nav.wishlist') }}
      </RouterLink>
    </div>
    <div class="flex items-center gap-4">
      <UIPopover v-if="store.token.value" :duration="undefined" placement="bottom-end" :showArrow="false" trigger="click">
        <template #trigger>
          <UIButton :ghost="true" :circle="true" id="customSlotPopOver">
            <UIAvatar :src="undefined" :fallbackSrc="undefined">
              {{
                store.user.value.name
                  ?.split(' ')
                  .map(str => str[0])
                  .join('')
              }}
            </UIAvatar>
          </UIButton>
        </template>

        <template #header>
          <UITextSmNormal>{{ store.user.value.name }}</UITextSmNormal>
          <UITextSmNormal>{{ store.user.value.email }}</UITextSmNormal>
        </template>

        <UIButton @click="store.logout()" :linkGray="true" :text="true" id="logout-button" class="my-2 w-full text-left justify-start">
          <LogOut01Icon class="w-4 h-4 mr-2" />
          {{ t('nav.logout') }}
        </UIButton>
      </UIPopover>
      <UIButton type="primary" id="go-to-store-button" @click="goToStore()">{{ t('nav.goToStore') }}</UIButton>
    </div>
  </nav>
</template>
